import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { baseUrl } from "./config";

const firebaseConfig = {
  apiKey: "AIzaSyBb9ixNQV1oLMI4c7HTyhtSpMYwJKzKd9E",
  authDomain: "pushnotify-bcab6.firebaseapp.com",
  databaseURL: "https://pushnotify-bcab6.firebaseio.com",
  projectId: "pushnotify-bcab6",
  storageBucket: "pushnotify-bcab6.appspot.com",
  messagingSenderId: "1022946711972",
  appId: "1:1022946711972:web:be651be3e7016acd700931",
  measurementId: "G-RP4WYYNX8N",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const provider = new GoogleAuthProvider();
//https://stackoverflow.com/questions/56505508/firebase-auth-google-always-ask-for-account#:~:text=As%20poited%20in%20Firebase%20google%20auth%20automatically%20selecting%20user.%20How%20to%20force%20it%20to%20select%20account
provider.setCustomParameters({
  prompt: "select_account",
});
const GSignIn = (props) => {
  const { setMsgbotUser, setLoading } = props;

  const SignInWithGoogle = async () => {
    const userInfo = await signInWithPopup(auth, provider);
    if (!userInfo?.user) alert("Something went wrong, Login again");
    const { displayName, email } = userInfo?.user;

    setLoading(true);
    await fetch(`https://msgbot-server.onrender.com/user/signIn`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        name: displayName,
        email: email,
      }),
    })
      .then((e) => e.json())
      .then((e) => {
        if (!e.length) return alert("Something went wrong, Login again");
        setMsgbotUser(e[0]);
      })
      .catch((e) => console.error(e));
    setLoading(false);
  };

  return (
    <button className="btn-block btn-color" onClick={SignInWithGoogle}>
      Sign in with Google
    </button>
  );
};

const handleSignOut = () => {
  auth.signOut();
};

export { GSignIn, handleSignOut };
